// client\src\pages\auth\signup.jsx

import { useState } from 'react';
import { useEffect } from 'react';
import styles from '../../App.module.css';
// import { Link, useNavigate } from "react-router-dom";
// import useAuth from "../../hooks/useAuth";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import api from '../../api/axios';


// Máscara para CPF
const formatCpf = (cpf) => {
  return cpf
    .replace(/\D/g, '') // Remove caracteres não numéricos
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

// Remove formatação do CPF
const unformatCpf = (cpf) => cpf.replace(/\D/g, '');



function Signup() {

  const [userLogin, setUserLogin] = useState("");
  const [userNome, setUserNome] = useState("");
  const [userSenha, setUserSenha] = useState("");


  const [userPermission] = useState(0);
const [userStatus] = useState(0);
  const [cpf, setCpf] = useState("");
  const [notificationType, setNotificationType] = useState(0);
  const [errorField, setErrorField] = useState('');
  const [errorMessage, setErrorMessage] = useState('');


  const validateFormUsers = () => {
    if (userLogin === "" || userSenha === "" || cpf === ""|| userNome === "" || unformatCpf(cpf).length !== 11) {
      return false;
    }
    return true;
  };



  /* Notificações Customizadas */
  useEffect(() => {
    if (notificationType === 1) {
      setNotificationType(0);
      return NotificationManager.success('Cliente cadastrado com sucesso!', 'Cadastrado', 3000);
    } else if (notificationType === 2) {
      setNotificationType(0);
      return NotificationManager.error('Ocorreu um erro ao cadastrar, cheque se as informações estão corretas!', 'Erro ao Cadastrar', 3000);
    } else if (notificationType === 3) {
      setNotificationType(0);
      return NotificationManager.warning('Você deve preencher todos os campos para cadastrar!', 'Campos Vazios', 3000);
    } else if (notificationType === 4) {
      setNotificationType(0);
      return NotificationManager.success('Cliente deletado com sucesso!', 'Deletado', 3000);
    } else if (notificationType === 5) {
      setNotificationType(0);
      return NotificationManager.error('Não foi possível deletar este usuário, entre em contato com o desenvolvedor!', 'Não foi possível', 3000);
    } else if (notificationType === 6) {
      setNotificationType(0);
      return NotificationManager.success('O Status do usuário foi atualizado!', 'Status', 3000);
    } else if (notificationType === 7) {
      setNotificationType(0);
      return NotificationManager.error('Não foi possível alterar o status do usuário, entre em contato com o desenvolvedor!', 'Status', 3000);
    } else if (notificationType === 8) {
      setNotificationType(0);
      return NotificationManager.success('Os dados foram atualizados com sucesso!', 'Atualizado', 3000);
    } else if (notificationType === 9) {
      setNotificationType(0);
      return NotificationManager.error('Não foi possível atualizar os dados do usuário, entre em contato com o desenvolvedor!', 'Erro ao Atualizar', 3000);
    } else if (notificationType === 10) {
      setNotificationType(0);
      return NotificationManager.warning('Você deve preencher todos os campos para editar!', 'Campos Vazios', 3000);
    } else if (notificationType === 11) {
      setNotificationType(0);
      return NotificationManager.success('Os dados foram copiados!', 'Dados Copiados', 3000);
    } else if (notificationType === 12) {
      setNotificationType(0);
      return NotificationManager.success('Todos os cadastros foram removidos do banco de dados! Atualize a página (F5).', 'Dados Removidos', 3000);
    } else if (notificationType === 13) {
      setNotificationType(0);
      return NotificationManager.success('Cadastro massivo finalizado com sucesso!', 'Clientes Cadastrados', 3000);
    } else if (notificationType === 14) {
      setNotificationType(0);
      return NotificationManager.warning('Você deve preencher o campo com dados válidos para realizar a importação!', 'Cuidado!', 3000);
    } else if (notificationType === 15) {
      setNotificationType(0);
      return NotificationManager.warning('Não existe nenhum cliente anterior a este, por favor, verifique e tente novamente!', 'Atenção!', 3000);
    } else if (notificationType === 16) {
      setNotificationType(0);
      return NotificationManager.warning('Não existe nenhum cliente sucessor a este, por favor, verifique e tente novamente!', 'Atenção!', 3000);
    } else if (notificationType === 17) {
      setNotificationType(0);
      return NotificationManager.warning('Este cliente já está no fim da lista!', 'Atenção!', 3000);
    } else if (notificationType === 18) {
      setNotificationType(0);
      return NotificationManager.warning('Este cliente já está no começo da lista!', 'Atenção!', 3000);
    } else if (notificationType === 19) {
      setNotificationType(0);
      return NotificationManager.success('Não se esqueça de encaminhar o comprovante no grupo vermelho.', 'Copiado!', 3000);
    }
  }, [notificationType]);

  /* Insere os dados somente se todos os campos requeridos estiverem preenchidos. */
  const insertDataUsers = async () => {
    if (validateFormUsers()) {
      try {
        const res = await api.post('/createUsers', {
          userLogin,
          userNome,
          userSenha,
          userPermission,
          userStatus,
          cpf: unformatCpf(cpf)
        });

        if (res.data.status) {
          NotificationManager.success('Usuário cadastrado com sucesso!', 'Cadastrado', 3000);
          setUserLogin('');
          setUserNome('');
          setUserSenha('');
          setCpf('');
          setErrorField('');
          setErrorMessage('');
        }
      } catch (error) {
        const { response } = error;
        if (response && response.data) {
          setErrorField(response.data.field || '');
          setErrorMessage(response.data.error || 'Erro desconhecido.');
        }
        NotificationManager.error(response.data.error, 'Erro ao Cadastrar', 3000);
      }
    }
  };


  const [error, setError] = useState("");


  const validateCpf = (cpf) => {
    // Remove caracteres não numéricos
    const unformattedCpf = cpf.replace(/\D/g, '');
  
    // Verifica se o CPF possui 11 dígitos ou se todos os dígitos são iguais
    if (unformattedCpf.length !== 11 || /^(\d)\1+$/.test(unformattedCpf)) {
      return false;
    }
  
    // Função para calcular o dígito verificador
    const calcDigit = (base, factor) => {
      let total = 0;
      for (let i = 0; i < base.length; i++) {
        total += parseInt(base[i]) * factor--;
      }
      const remainder = total % 11;
      return remainder < 2 ? 0 : 11 - remainder;
    };
  
    // Calcula os dígitos verificadores
    const baseCpf = unformattedCpf.slice(0, 9);
    const firstDigit = calcDigit(baseCpf, 10);
    const secondDigit = calcDigit(baseCpf + firstDigit, 11);
  
    // Verifica se os dígitos calculados conferem com os do CPF
    return firstDigit === parseInt(unformattedCpf[9]) && secondDigit === parseInt(unformattedCpf[10]);
  };
  
  

  const handleSignup = () => {
    if (!userLogin || !userSenha || !cpf) {
      setError("Preencha todos os campos");
      return;
    }
  
    if (!validateCpf(cpf)) {
      setError("CPF não existe");
      return;
    }
  
    insertDataUsers();
  };
  
  

  return (
    <div >
      <NotificationContainer />
      <div className={styles.container}>
        <div className={styles.label}>
          <h1>CADASTRO</h1>

          <p>Insira o seu email e senha para continuar</p>
        </div>
        <div className={styles.content}>
        <input
            className={`${styles.input} ${errorField === 'nome' ? styles.errorInput : ''}`}
            type="text"
            placeholder="Digite seu Nome"
            value={userNome}
            maxLength={14}
            onChange={(e) => {
              setUserNome(e.target.value);
              setErrorField('');
              setErrorMessage('');
            }}
          />
            {errorField === 'nome' && errorMessage}


          <input
            className={`${styles.input} ${errorField === 'cpf' ? styles.errorInput : ''}`}
            type="text"
            placeholder="Digite seu CPF"
            value={formatCpf(cpf)}
            maxLength={14}
            onChange={(e) => {
              setCpf(e.target.value);
              setErrorField('');
              setErrorMessage('');
            }}
          />
          <div className={styles.errorMessage}>
            {errorField === 'cpf' && errorMessage}
          </div>
          <input
            className={`${styles.input} ${errorField === 'userLogin' ? styles.errorInput : ''}`}
            type="email"
            placeholder="Digite seu E-mail"
            value={userLogin}
            onChange={(e) => {
              setUserLogin(e.target.value);
              setErrorField('');
              setErrorMessage('');
            }}
          />
           <div className={styles.errorMessage}>
            {errorField === 'userLogin' && errorMessage}
          </div>
          <input
            className={`${styles.input} ${errorField === 'userSenha' ? styles.errorInput : ''}`}
            type="password"
            placeholder="Digite sua Senha"
            value={userSenha}
            onChange={(e) => {
              setUserSenha(e.target.value);
              setErrorField('');
              setErrorMessage('');
            }}
          />
          <div className={styles.errorMessage}>
            {errorField === 'userSenha' && errorMessage}
          </div>

          <div className={styles.labelerror}>{error}</div>
          <button className={styles.button} Text="Inscrever-se" onClick={handleSignup}>Inscrever-se</button>
          <div className={styles.labelsignin}>
            Já tem uma conta?
            <div className={styles.strong}>
              <a href="/" >
                &nbsp;Entre
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )














}

export default Signup